import * as Sentry from "@sentry/browser";
import { AxiosError } from "axios";
import { Dispatch } from "redux";
import { StatusCodes } from "http-status-codes";
import mixpanel from "mixpanel-browser";
import { toast } from "react-toastify";

import {
  CLEAR_INVITED_USER_ERROR,
  INVITED_USER_ALREADY_ASSOCIATED_WITH_ORGANIZATION,
} from "../constants";
import { EOrganizationType, IAppState } from "../../interfaces/interfaces";
import EWebAPIError from "../../api/errors";
import { getToken } from "../../utils/auth_token";
import { postInviteManager } from "../../api/organizations";

export const inviteManager =
  (
    email: string,
    closeModalFn: () => void,
    refetch: () => void,
    organizationId: string,
    organizationName: string,
    organizationType: EOrganizationType,
    userId: string
  ) =>
  async (dispatch: Dispatch): Promise<void> => {
    try {
      await postInviteManager(email, organizationId, getToken() || "");
      closeModalFn();
      refetch();
      toast("Invite Sent");
      if (organizationType === EOrganizationType.PRO_VIEW_ORGANIZATION) {
        mixpanel.track("Invite Manager Sent", {
          invited_manager: email,
          organizationName,
          organization_id: organizationId,
          user_id: userId,
        });
      }
    } catch (error) {
      /* eslint-disable camelcase */
      const { response, message } = error as AxiosError<{
        error_id: EWebAPIError;
      }>;
      if (
        response &&
        response.status === StatusCodes.CONFLICT &&
        response.data.error_id === EWebAPIError.USER_ALREADY_EXISTS_FOR_PROPERTY
      ) {
        dispatch({ type: INVITED_USER_ALREADY_ASSOCIATED_WITH_ORGANIZATION });
      } else {
        Sentry.captureMessage(
          `Route "emails_send_admin_portal_invitation" returned unexpected error: ${JSON.stringify(
            (response && response.data) || message
          )}`
        );
      }
    }
  };

export const clearInvitedUserError = (
  dispatch: Dispatch,
  getState: () => IAppState
): void => {
  if (getState().userManagement.invitedUserError)
    dispatch({ type: CLEAR_INVITED_USER_ERROR });
};
